// extracted by mini-css-extract-plugin
export var button = "_62-7";
export var buttonRow = "_62-6";
export var fadeIn = "_62-1";
export var gradient = "_62-0";
export var panel = "_62-2";
export var panelIn = "_62-3";
export var subtitle = "_62-5";
export var title = "_62-4";